import { useReplaceLocation } from '../contact'
import { type AddHookResponse, mutationAdd } from '../hooks'
import { useLocationCache } from '../location'
import { useTantalimMutation } from '../mutation'
import { type OnLocationMutate } from './types'
import {
  Logger,
  toResponseError,
  type ExtendedLocationData,
  type LocationResidentInput,
  type LocationResidentSuccess,
} from '@terros/common'

const logger = new Logger('resident')

export function useAddLocationResident(
  onMutate: OnLocationMutate
): AddHookResponse<LocationResidentInput, ExtendedLocationData> {
  const replaceLocation = useReplaceLocation()
  const { replaceItem } = useLocationCache()

  const mutation = useTantalimMutation<LocationResidentInput, LocationResidentSuccess>({
    url: '/location/resident',
  })

  async function add(input: LocationResidentInput): Promise<ExtendedLocationData> {
    const { locationId } = input
    try {
      const { location: newLocation } = await mutation.mutateAsync({ version: 3, ...input })
      logger.verbose('saved location', newLocation)

      replaceLocation({
        locationId,
        newLocation,
      })
      replaceItem(locationId, newLocation)
      await onMutate(locationId, newLocation.locationId)
      return newLocation
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationAdd(mutation, add)
}
